import React from "react";
import { Formik, Form } from "formik";
import l from "components/util/l";
import { Modal } from "seed/helpers";
import Navigator from "components/brief/reviewer/revision/layout/helpers/RevisionSectionNavigator";
import RevisionToolbar from "components/brief/reviewer/revision/layout/helpers/RevisionToolbar";
import RevisionProposalActions from "components/brief/reviewer/revision/layout/helpers/RevisionProposalActions";
import RevisionContent from "components/brief/reviewer/revision/content/RevisionContent";
import SaveRevision from "components/brief/util/helpers/SaveRevision";
import HtmlPreview from "components/brief/util/helpers/HtmlPreview";
import "styles/css/agent/Revision.css";

const RevisionFormLayout = ({
  flow,
  sections,
  currentSection,
  indexSections,
  visibleSections,
  allowComments,
  activeSectionIndex,
  isSaving,
  isCreatingDevRevision,
  showProposalActions,
  showSectionNavigator,
  prototypeFile,
  extraActions,
  isPrototypeOpen,
  setIsPrototypeOpen,
  onClickPrevSection,
  onClickNextSection,
  onClickSelectSection,
  onClickEditProposal,
  onClickSaveRevision,
  onCloseSaveRevisionForm,
  onSubmitSaveRevisionForm,
  onClickSaveDraft,
  saveRevisionForm,
}) => {
  

  return (
    <Formik
      initialValues={{}}
      onSubmit={onClickNextSection}
    >
      {({ values }) => (
        <Form
          className={"product-view-container d-flex flex-column overflow-hidden px-3 w-100 "
            + (showProposalActions || extraActions ? "bg-dark " : "")}
          style={{
            height: "90vh",
            minHeight: "90vh",
            maxHeight: "90vh",
            overflow: "hidden",
          }}
        >
          <div className="d-flex flex-column h-100 overflow-hidden" style={{ minHeight: 0 }}>
            {showSectionNavigator && (
              <RevisionToolbar
                activeSectionIdx={activeSectionIndex}
                sections={sections}
                values={values}
                allowComments={allowComments}
                isSaving={isSaving}
                onClickPrevSection={onClickPrevSection}
                onClickSelectSection={onClickSelectSection}
                onClickSaveDraft={onClickSaveDraft}
                onClickSaveRevision={() => onClickSaveRevision({ sections, values, activeSectionIndex })}
              />
            )}

          {showProposalActions && (
            <RevisionProposalActions
              isCreatingDevRevision={isCreatingDevRevision}
              onClickEditProposal={onClickEditProposal}
            />
          )}

          {extraActions && (
            <div className="d-flex w-100 justify-content-end mt-2">
              {extraActions}
            </div>
          )}

          {/* The prototype is reachable from every section, not only from its own tab */}
          {prototypeFile && (
            <div className="d-flex w-100 justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-light"
                onClick={() => setIsPrototypeOpen(true)}
              >
                <i className="fas fa-file-code mr-2"></i>
                {l("Prototipo%PA560")}
              </button>
            </div>
          )}

          {showSectionNavigator &&
            currentSection.staticType !== "preliminary" &&
            currentSection.staticType !== "objective" &&
            currentSection.staticType !== "index" && (
              <div className={showProposalActions || extraActions ? "mt-n3" : ""} style={{ zIndex: 1000 }}>
                <Navigator
                  currentSection={currentSection}
                />
              </div>
            )
          }

          <RevisionContent
            flow={flow}
            activeSectionIdx={activeSectionIndex}
            currentSection={currentSection}
            indexSections={indexSections}
            visibleSections={visibleSections}
            onClickEditProposal={showProposalActions ? onClickEditProposal : null}
            onClickNextSection={onClickNextSection}
            onClickSelectSection={onClickSelectSection}
            onClickSaveRevision={() => onClickSaveRevision({ sections, values, activeSectionIndex })}
            isSaving={isSaving}
          />
        </div>

        {saveRevisionForm &&
          <Modal width={560} height={600} closeOnEsc={false} onClose={onCloseSaveRevisionForm}>
            <SaveRevision flow={flow} revision={saveRevisionForm} onSubmit={onSubmitSaveRevisionForm} />
          </Modal>}

        {/* Modals: the prototype at full size, and the publish form */}
        {isPrototypeOpen && (
          <Modal width={1400} height={900} overflow="hidden" onClose={() => setIsPrototypeOpen(false)}>
            <div className="h-100 bg-white">
              <HtmlPreview file={prototypeFile} fullWidth={true} />
            </div>
          </Modal>
        )}
      </Form>
    )}
  </Formik>
  );
}

export default RevisionFormLayout;
